import { render, staticRenderFns } from "./20201026.vue?vue&type=template&id=47a1b1c2&lang=pug&"
var script = {}
import style0 from "./20201026.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a1b1c2')) {
      api.createRecord('47a1b1c2', component.options)
    } else {
      api.reload('47a1b1c2', component.options)
    }
    module.hot.accept("./20201026.vue?vue&type=template&id=47a1b1c2&lang=pug&", function () {
      api.rerender('47a1b1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/20201026.vue"
export default component.exports